module.exports = __webpack_public_path__ + "img/volvo_collect.5b48772d.svg";